<template>
  <b-card-group deck id="inst-cards-list">
    <b-card
      align="left"
      v-for="inst in instruments"
      :key="`${inst.id}--instpage`"
      :id="`${inst.id}--instpage`"
      class="inst-info-card"
      body-class="inst-info-body"
      style="min-width: 25rem; margin: 1rem;"
    >
      <div >
        <!-- 1em = 16px -->
        <!-- 15px/16px = 0.9375em -->
        <!-- 14px/16px = 0.875em, (1em = 16px) -->
        <p style="font-size: 0.9375rem;">
          <strong>
            <span
              v-bind:style="{ color: getIconIndicatorColors(`${inst.id}`)}"
            >
              <i
                class="fas fa-database"
                v-b-popover.hover.top="getIconIndicatorText(`${inst.id}`)"
              ></i>
            </span>
              {{inst.formal_name}}
            <span class="text-muted">
              {{siteName(inst.id)}}
            </span>
            <!--Status indicator icon using nereus information-->
            <status-indicator
              :instRD="inst.id"
            ></status-indicator>
          </strong>
          <br>
          <small>
          <strong>Total Size:</strong> {{inst.size}} |
          <strong>Instrument group:</strong> {{inst.group}}
          </small>
        </p>
        <p style="font-size: 0.875rem;">
            <strong>Instrument ID:</strong> {{inst.id}}<br>
            <strong>Total bytes:</strong> {{inst.total_bytes}}
        </p>
      </div>
      <template #footer>
        <div>
          <div style="display: inline;">
            <b-btn
              :id="`${inst.id}--streamInfoBtn`"
              variant="primary"
              size="sm"
              v-b-modal="`${inst.id}--streamModal`"
              @click.prevent="getStreamInfo(inst.id)"
            > Stream Information
              <b-badge
                variant="light"
              >{{inst.num_streams}}</b-badge>
            </b-btn>
            <b-btn
              variant="primary"
              size="sm"
              :href="`${inst.url}`"
              target="_blank"
            >
              Learn More
              <i class="fas fa-external-link-alt fa-sm"></i>
            </b-btn>
          </div>
        </div>
      </template>
      <!--Modal to display stream information for selected instrument-->
      <b-modal
        :id="`${inst.id}--streamModal`"
        size="xl"
        :title="`${inst.formal_name} (${inst.id})`"
        header-text-variant="primary"
        hide-footer
        centered
      >
        <b-container fluid style="padding: 0">
          <b-row>
            <b-col cols="12">
              <b-card no-body>
                <b-tabs pills vertical card style="font-size: 0.875rem;, ">
                  <b-tab
                    v-for="stream in streamObj.streams"
                    :key="`${stream.id}-streamTab`"
                    :id="`${stream.id}-streamTab`"
                    :title="getStreamTab(stream.id, stream.instrument_rd)"
                    @click="getTabID"
                  >
                    <b-card-text>
                      <p style="font-size: 0.9375rem;" class="text-center">
                        <strong>{{stream.id}}</strong>
                        <br>
                        <small>
                          <strong>Instrument RD:</strong> {{stream.instrument_rd}}
                        </small>
                        <br>
                        <small>
                          <strong>Total Size:</strong> {{stream.size}} |
                          <strong>Total Bytes:</strong> {{stream.bytes_size}}
                        </small>
                      </p>
                      <hr>
                      <p style="font-size: 0.875rem;">
                        <strong>Data Location:</strong> {{stream.data_location}}<br>
                        <strong>Start Date:</strong> {{stream.start_dt}}<br>
                        <strong>End Date:</strong> {{stream.end_dt}}<br>
                      </p>
                    </b-card-text>
                    <b-tabs content-class="mt-3" fill>
                      <b-tab>
                        <template v-slot:title>
                          Data Products
                          <b-badge
                            pill
                            variant="info"
                          >{{stream.num_data_products}}</b-badge>
                        </template>
                        <p v-if="stream.num_data_products === 0" class="text-center">
                          <strong>No data products found.</strong>
                        </p>
                        <b-table
                          v-if="stream.num_data_products > 0"
                          hover
                          :items="getDataProducts(stream)"
                          small>
                        </b-table>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          Variables
                          <b-badge pill variant="info">{{stream.num_variables}}</b-badge>
                        </template>
                        <p v-if="stream.num_variables === 0" class="text-center">
                          <strong>No variables found.</strong>
                        </p>
                        <b-table
                          v-if="stream.num_variables > 0"
                          hover
                          :items="stream.variables"
                          small>
                        </b-table>
                      </b-tab>
                    </b-tabs>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
    </b-card>
  </b-card-group>
</template>
<script>
// import axios from 'axios';
import _ from 'lodash';
import StatusIndicatorVue from '../statusIndicators/StatusIndicatorDisplay';

export default {
  props: ['instruments'],
  data() {
    return {
      streamObj: {},
      streamName: null,
    };
  },
  components: {
    'status-indicator': StatusIndicatorVue,
  },
  methods: {
    // To get the id of the clicked element for GA
    getBtnID(refdes) {
      this.$ga('event', `${refdes}--streamInfoBtn`);
    },
    // To get the id of the clicked element for GA
    getTabID(event) {
      this.$ga('event', event.target.id);
    },
    // Gets the site rd from instrument ID to place on card title
    siteName(ref) {
      const siteName = ref.slice(0, 8);
      return siteName;
    },
    // Filters down to streams available within each instrument
    getStreamInfo(refdes) {
      this.getBtnID(refdes);
      const instObj = this.instruments;
      this.streamObj = _.head(_.filter(instObj, ['id', refdes]));
    },
    // Shorten names for each tab - removes instrumentRD and keeps stream info
    getStreamTab(streamRD, instRD) {
      const streamName = streamRD.replace(instRD, '');
      return streamName.replace('-', '');
    },
    // Maps the data products available from the listing of variables
    getDataProducts(stream) {
      const { variables } = stream;
      const dataProducts = stream.data_products;
      return _.filter(variables, (v) => _.includes(dataProducts, v.name));
    },
    // Helper method to filter through the statusIndicator information
    getInstHelper(refDes) {
      const instHolder = _.head(_.filter(this.instruments, [
        'id',
        refDes,
      ]));
      return instHolder;
    },
    // Grabs the total bytes for each instruments and assigns a color to determine data size
    getIconIndicatorColors(refDes) {
      let color;
      const iconHolderColor = this.getInstHelper(refDes);
      if (!_.isNumber(iconHolderColor.total_bytes)) {
        color = 'Black';
      } else if (iconHolderColor.total_bytes < (1024 ** 2)) {
        // > KiB kibibyte, < MiB mebibyte
        color = '#9fc7d2';
      } else if (
        iconHolderColor.total_bytes > (1024 ** 2) && iconHolderColor.total_bytes < (1024 ** 3)
      ) { // > MiB mebibyte, < GiB gibibyte
        color = '#7fc7d2';
      } else if (
        iconHolderColor.total_bytes > (1024 ** 3) && iconHolderColor.total_bytes < (1024 ** 4)
      ) { // > GiB gibibyte, < TiB tebibyte
        color = '#62bbc8';
      } else if (
        iconHolderColor.total_bytes > (1024 ** 4) && iconHolderColor.total_bytes < (1024 ** 5)
      ) { // > TiB tebibyte, < PiB pebibyte
        color = '#45aebe';
      } else if (
        iconHolderColor.total_bytes > (1024 ** 5) && iconHolderColor.total_bytes < (1024 ** 6)
      ) { // > PiB pebibyte, < EiB exbibyte
        color = '#3995a3';
      } else if (
        iconHolderColor.total_bytes > (1024 ** 6) && iconHolderColor.total_bytes < (1024 ** 7)
      ) { // > EiB exbibyte, < ZiB zebibyte
        color = '#2f7a86';
      } else if (
        iconHolderColor.total_bytes > (1024 ** 7) && iconHolderColor.total_bytes < (1024 ** 8)
      ) { // > ZiB zebibyte, < YiB yobibyte
        color = '#256069';
      } else if (iconHolderColor.total_bytes > (1024 ** 8)
      ) { // > YiB yobibyte
        color = '#1b454c';
      }
      return color;
    },
    // Saves data size so user can see when hover over icon
    getIconIndicatorText(refDes) {
      const statusHolderText = this.getInstHelper(refDes);
      let text;
      if (_.isEmpty(statusHolderText)) {
        text = 'Data not available';
      } else {
        text = statusHolderText.size;
      }
      return text;
    },
  },
};

</script>
